import React, { Fragment } from 'react'
import { Button, Input } from '@drifthq/tide-core'

import UIDropArea from 'components/UIDropArea'
import DropZone from 'react-dropzone'

import './style.css'

export const ProfilePhotoStep = ({
  onDrop,
  user,
  profile,
  isUploadingCoverPhoto,
  onContinueClick,
  onSkipClick,
  onNameChange,
  name,
  isRepInvitedFlow,
  isSSOProvisionedFlow,
  stagedProfilePicture
}) => {
  return (
    <Fragment>
      <h1>Personalize your Conversational Sales Profile</h1>
      <p>Your Drift Profile is your digital business card where people can book meetings and chat in real time with you.</p>
      <Input
        required
        value={name}
        onChange={onNameChange}
        label="What's your name?"
        placeholder="Michael Scott"
        className="full-width-component"
      />
      <UIDropArea user={user} profile={profile} stagedProfilePicture={stagedProfilePicture} uploadAvatar={onDrop} isUploadingCoverPhoto={isUploadingCoverPhoto}/>
      <div className='continue-button'>
        <Button onClick={onContinueClick}>{
          isSSOProvisionedFlow ? 'Continue to Meetings' :
          isRepInvitedFlow ? 'Continue to your Password' :
          'Continue to Profile Color'
        }</Button>
      </div>
    </Fragment>
  )
}

export const AEProfilePhotoStep = ({
  onDrop,
  onContinueClick,
  onSkipClick,
  onNameChange,
  name,
  isRepInvitedFlow,
  isSSOProvisionedFlow,
  avatarUrl,
}) => {
  return (
    <Fragment>
      <h1>Introduce yourself&nbsp;<span role="img" aria-label="wave" className="header-text-emoji">👋</span></h1>
      <p>When a teammate books a meeting for you, let them know who they&rsquo;ll be meeting with.</p>
      <Input
        className="full-width-component"
        label="Your name"
        placeholder="Chelsea Ward"
        value={name}
        onChange={onNameChange}
        size="large"
      />
      <Fragment>
        <label className="full-width-component">
          Your avatar
        </label>
        <DropZone
          className='profile-avatar'
          onDrop={onDrop}
        >
          <div style={{ backgroundImage: `url(${avatarUrl})` }} className="profile-photo" />
          <div className="profile-avatar-description">Drag and Drop or <span className="profile-avatar-text">Choose a file</span> to upload</div>
        </DropZone>
      </Fragment>
      <div className="continue-button full-width-component">
        <Button 
          type="primary" 
          size="large" 
          onClick={onContinueClick}
          disabled={!name}
          >
          Continue
        </Button>
      </div>
    </Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/layouts/ProfilePhotoStep/component.js